import { ZagentMiniConfig } from './zerops-services.model';

/**
 * Zagent environment key constant
 * Used to identify AI Agent environment in recipe configurations
 */
export const ZAGENT_ENVIRONMENT_KEY = 'ai-agent';

/**
 * Zcde environment key constant
 * Used to identify Remote CDE environment in recipe configurations
 */
export const ZCDE_ENVIRONMENT_KEY = 'remote-cde';

/**
 * Placeholder project ID used when opening AI Agent dialog
 * before a project exists (e.g., during project creation flows).
 */
export const PENDING_PROJECT_ID = 'pending';

/**
 * Internal port code-server (Cloud IDE) listens on inside a control plane service.
 */
export const CODE_SERVER_PORT = 8080;

/**
 * Default configuration for zagent mini card
 * Note: selectedServices empty means "use dev-suffixed services from context"
 */
export const DEFAULT_ZAGENT_MINI_CONFIG: ZagentMiniConfig = {
  enableAgent: true,
  enableVscode: true,
  agentType: 'claude-code',
  authType: 'oauth',
  provider: 'anthropic',
  includeVscode: true,
  enablePublicAccess: true,
  selectedServices: []  // Empty = derive from services input (dev-suffixed)
};

/**
 * Helper to compute default selected services from a services list
 */
export const getDefaultSelectedServices = (
  services: Array<{ name: string }>
): string[] => {
  return services
    .filter(s => s.name.toLowerCase().includes('dev'))
    .map(s => s.name);
};
